import React, { useCallback } from 'react';

import { Pencil } from 'lucide-react';
import type { SingleValue } from 'react-select';

import { Select } from '@/_components';
import { ActionButton, ActionButtonContainer } from '@/_containers';
import type { SKUQuerySchema } from '@/_pages/settings/inventory-kits/shared/schemas/skus';
import { snackbar, useCopyToClipboard } from '@/_shared';

import type { SKUsProps } from './shared';

const PreviewSKUsBase = ({ value, onOpen, isEditable }: Omit<SKUsProps, 'onChange'> & { onOpen: () => void }) => {
  const { copy } = useCopyToClipboard();

  const handleOnChange = useCallback(
    (e: SingleValue<SKUQuerySchema>) => {
      copy(e?.sku || '');
      snackbar.success(`${e?.sku || ''} has been copied to clipboard`);
    },
    [copy]
  );

  return (
    <section className="flex flex-nowrap">
      <Select
        label="Secondary SKU"
        onChange={handleOnChange}
        value={value?.[0]}
        options={value}
        getOptionLabel={(items) => items.sku}
        isClearable={false}
        labelProps={{ className: isEditable ? 'w-[calc(100%_+_1.75rem)]' : '' }}
        menuClassName={isEditable ? 'w-[calc(100%+1.75rem)]!' : ''}
      />
      {isEditable && (
        <ActionButtonContainer>
          <ActionButton title="Edit Secondary SKUs" disabled={!value} icon={Pencil} onClick={onOpen} />
        </ActionButtonContainer>
      )}
    </section>
  );
};

export const PreviewSKUs = React.memo(PreviewSKUsBase);
